import { SignInPage } from "../components"

export default SignInPage
